import { createStore, withProps } from '@ngneat/elf';
import {
  DynaDocsResponse,
  DynaDocsDto,
  TemplateResponse,
  DynaStatus,
  DacCreateDto,
  DacFormFields,
  DacPrixRequest,
  DacCreateDtoSupport,
  DacResponse,
  DacUpdateDto,
  ParamGeneralDacValueDto,
  DacUpdateConfigDto,
} from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface DacStateProps {
  //dynadocs
  response: DynaDocsResponse;
  dto: DynaDocsDto;
  //dac ************************************************************************
  //dac create dto
  dacCreateDto?: DacCreateDto;
  dacCreateDtoSupport: DacCreateDtoSupport;

  dacUpdateDto: DacUpdateDto;
  dacUpdateConfigDto?: DacUpdateConfigDto;
  initialDacUpdateDto?: DacUpdateDto;

  dacFormFields: DacFormFields[];
  initialDacFormFields?: DacFormFields[];

  dacHasRightToSubmit: boolean;
  dacHasRightToSubmitTouched: boolean;

  dacInfo?: DacResponse;
  dacPrix: DacPrixRequest[];
  generalParamDefinitions: ParamGeneralDacValueDto[];

  //select options **************************************************************
  ppmSelected: SelectOption;
  milestoneSelected: SelectOption;
  isStaticSelected: SelectOption;
  isAAOSelected: SelectOption;
  typeMarcheIdSelected?: SelectOption;
  modePassationIdSelected?: SelectOption;
  statusIdSelected?: SelectOption;
  comSelected?: SelectOption;
  comMemberSelected?: SelectOption;
  dynaDocsModelIdSelected?: SelectOption;
  responsableSelected?: SelectOption;
  scenarioIdSelected?: SelectOption;

  templateMetadata?: TemplateResponse;
  guideMetadata?: TemplateResponse;
  pendingTemplateFile?: File;
  pendingGuideFile?: File;
  staticFiles?: Record<number, File | null>;
  download: {
    formatSelected?: SelectOption;
  };
  upload: {
    modelDacFile: File[];
    dacFile: File[];
    scenarioId?: number;
    password: string;
    confirmPassword: string;
  };
  review: {
    comment: string;
    files: File[];
  };
}

export const dacInitialState: DacStateProps = {
  response: {
    id: 0,
    version: 0,
    name: '',
    templateFileName: '',
    guideFileName: '',
    typeMarche: { id: 0, description: '', code: '' },
    modePassation: { id: 0, libelle: '', restraint: false, type: null, etapes: null },
    dynaDocOrder: 0,
    status: DynaStatus.ACTIF,
    fields: [],
    isStatic: false,
    isAAO: false,
  },
  dto: {
    id: 0,
    version: 0,
    name: '',
    templateFileName: '',
    guideFileName: '',
    typeMarcheId: 0,
    modePassationId: undefined,
    dynaDocOrder: 0,
    status: DynaStatus.ACTIF,
    fields: [],
    isStatic: false,
    isAAO: false,
  },
  dacInfo: undefined,
  dacPrix: [],
  generalParamDefinitions: [],

  dacFormFields: [],
  dacUpdateDto: {
    dacId: undefined,
    payant: false,
    responsableDacId: undefined,
    conditionsParticipation: '',
    shortlistMembers: [],
    dacPrixRequests: [],
    dacDocsRequests: [],
    dacDynaFormRequest: [],
    dateDebutDepot: undefined,
    dateLimiteSoumission: undefined,
    dateLimiteRecptionDemande: undefined,
    dateOuverture: undefined,
    parametrageGeneralDacValuesRequests: [],
  },
  dacUpdateConfigDto: {
    scenarioId: undefined,
    dacDocSoumissionCreateRequests: [],
  },

  dacHasRightToSubmit: false,
  dacHasRightToSubmitTouched: false,

  //select options **************************************************************
  ppmSelected: { name: '', code: undefined },
  milestoneSelected: { name: '', code: undefined },
  isStaticSelected: { name: 'Dynamique', code: 'false' },
  isAAOSelected: { name: 'Non', code: 'false' },
  typeMarcheIdSelected: { name: '', code: 0 },
  modePassationIdSelected: { name: '', code: undefined },
  statusIdSelected: { name: '', code: DynaStatus.ACTIF },
  dynaDocsModelIdSelected: { name: '', code: undefined },
  responsableSelected: { name: '', code: undefined },
  comSelected: { name: '', code: undefined },
  comMemberSelected: { name: '', code: undefined },
  scenarioIdSelected: { name: '', code: undefined },

  pendingTemplateFile: undefined,
  pendingGuideFile: undefined,
  templateMetadata: {
    fileName: '',
    lastModified: 0,
    mimeType: '',
    size: 0,
    templateName: '',
  },
  guideMetadata: {
    fileName: '',
    lastModified: 0,
    mimeType: '',
    size: 0,
    templateName: '',
  },
  dacCreateDto: {
    appelOffreId: undefined,
    dynaDocsModelId: undefined,
  },
  dacCreateDtoSupport: {
    aoRef: '',
    ppmRef: '',
    milestoneRef: '',
  },
  staticFiles: {},
  download: {
    formatSelected: { name: 'PDF', code: 'pdf' },
  },
  upload: {
    modelDacFile: [],
    dacFile: [],
    scenarioId: undefined,
    password: '',
    confirmPassword: '',
  },
  review: {
    comment: '',
    files: [],
  },
};

export const dacStateStore = createStore(
  { name: 'dynamic-docs-state' },
  withProps<DacStateProps>({
    ...dacInitialState,
  })
);
